import React, { memo } from 'react'

import MoreInformationWrapper from './MoreInformationWrapper'

const ShowMoreInformationWrapper = (props) => {
  return <MoreInformationWrapper {...props} />
}

export default memo(ShowMoreInformationWrapper)
